import type { CartValidationErrorDetails } from '../types/cart';
import { CartValidationErrorKey } from './notificationMaps';

export const extractDiscontinuedLineItemIds = (errors: CartValidationErrorDetails[]): string[] => [
    ...new Set(
        errors
            .filter(e => e.errorCode === CartValidationErrorKey.DISCONTINUED_PRODUCT)
            .map(e => e.lineItemId)
            .filter((id): id is string => Boolean(id))
    ),
];
